module.exports = __webpack_public_path__ + "static/media/force-device-on-wooden-texture-with-layer-min-final.b6b46fe6.jpg";